import React from 'react'
import Switch from 'lib/ui/form/Switch'
import {onChangeCheckedHandler} from 'lib/dom'
import {
  useHubspot,
  useServices,
} from 'organization/Event/Services/ServicesProvider'
import {useEvent} from 'Event/EventProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {useToggle} from 'lib/toggle'
import {api} from 'lib/url'
import {HubspotIntegration} from 'organization/Event/Services/Apps/Hubspot'

export default function SyncSwitch() {
  const {changeSync, processing} = useHubspotSync()
  const hubspot = useHubspot()
  const {event} = useEvent()
  return (
    <Switch
      checked={hubspot.sync_required}
      onChange={onChangeCheckedHandler(changeSync)}
      disabled={processing || event.has_ended}
      aria-label="toggle sync"
      labelPlacement="end"
      name="name"
      label="Sync attendees"
    />
  )
}

export function useHubspotSync() {
  const service = useServices()
  const {event} = useEvent()
  const {client} = useOrganization()
  const {flag: processing, toggle: toggleProcessing} = useToggle()

  const changeSync = (sync: boolean) => {
    if (processing) {
      return
    }

    const request = sync ? client.put : client.delete

    toggleProcessing()
    const url = api(`/events/${event.id}/integrations/hubspot/sync`)
    request<HubspotIntegration>(url)
      .then(service.update)
      .finally(toggleProcessing)
  }

  return {
    changeSync,
    processing,
  }
}
